import * as z from "zod";

export const setManagedReturnsBarcodeLabelTemplateEnabled = {
  name: "setManagedReturnsBarcodeLabelTemplateEnabled" as const,
  input: z.object({ templateId: z.string(), enabled: z.boolean() }),
  output: z.object({ templateId: z.string(), enabled: z.boolean() }),
};
